import { LoginScreen } from "@delorean/login";
import { redirectToFallback } from "../utils/securityUtils";
import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  SET_SCREEN,
  SET_ERROR,
  LOGIN_CANCEL_PROCEDURE,
  LOGIN_SUCCESS_QR_CODE,
  RESEND_NOTIFY,
  LOGIN_SESSION_EXPIRED,
} from "../actions/loginActions";
import {
  LOGIN_FORGET_PSW_ERROR_CHANNEL,
  LOGIN_FORGET_PSW_FAILURE,
  LOGIN_FORGET_PSW_REQUEST,
  LOGIN_FORGET_PSW_SUCCESS,
  LOGIN_RESET_TEMP_PSW_FAILURE,
  LOGIN_RESET_TEMP_PSW_REQUEST,
  LOGIN_RESET_TEMP_PSW_SUCCESS,
  RESET_PSW_CANCEL_PROCEDURE,
  RESET_PSW_SESSION_EXPIRED,
  RESET_PSW_SUCCESS_QR_CODE,
} from "@delorean/actions/resetPasswordActions";

type FirstFactorStateType = {
  mfaData: Record<string, any>;
  operationId: string;
  error: any;
  loading: boolean;
  isAuthenticated: boolean;
  screen: LoginScreen;
  userCode: string;
  contractCode: string;
  isPasswordChosen?: boolean;
};

const initialState: FirstFactorStateType = {
  mfaData: {},
  operationId: "",
  error: null,
  loading: false,
  isAuthenticated: false,
  screen: LoginScreen.DEFAULT,
  userCode: "",
  contractCode: "",
  isPasswordChosen: false,
};

const loginReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        isAuthenticated: action.payload?.isAuthenticated || false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        mfaData: action.payload.mfaData || {},
        operationId: action.payload.operationId || "",
        isAuthenticated: true,
        userCode: action.payload.userCode || "",
        contractCode: action.payload.contractCode || "",
      };
    case LOGIN_SUCCESS_QR_CODE:
      return {
        ...state,
        loading: false,
        mfaData: action.payload.mfaData || {},
        operationId: action.payload.operationId || "",
        isAuthenticated: true,
        screen: LoginScreen.APP_QRCODE,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        isAuthenticated: false,
      };
    case LOGIN_CANCEL_PROCEDURE:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
      };
    case LOGIN_RESET_TEMP_PSW_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: action.payload.isAuthenticated,
        screen: action.payload.screen,
        mfaData: action.payload.mfaData || {},
        operationId: action.payload.operationId || "",
        isPasswordChosen: true,
        userCode: action.payload.userCode || "",
      };
    case LOGIN_RESET_TEMP_PSW_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        isAuthenticated: false,
      };
    case LOGIN_RESET_TEMP_PSW_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        isAuthenticated: false,
      };
    case LOGIN_FORGET_PSW_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: action.payload.isAuthenticated,
        screen: action.payload.screen,
      };
    case LOGIN_FORGET_PSW_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        isAuthenticated: false,
      };
    case LOGIN_FORGET_PSW_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        isAuthenticated: false,
      };
    case LOGIN_FORGET_PSW_ERROR_CHANNEL:
      return {
        ...state,
        screen: action.payload.screen,
        loading: false,
        error: action.error,
        isAuthenticated: false,
      };
    case RESET_PSW_CANCEL_PROCEDURE:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        screen: action.payload.screen,
      };
    case RESET_PSW_SUCCESS_QR_CODE:
      return {
        ...state,
        loading: false,
        mfaData: action.payload.mfaData || {},
        operationId: action.payload.operationId || "",
        isAuthenticated: true,
        screen: LoginScreen.APP_QRCODE,
      };
    case SET_SCREEN:
      return {
        ...state,
        screen: action.payload.screen,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload.error,
      };
    case RESEND_NOTIFY:
      return {
        ...state,
        loading: false,
        mfaData: action.payload.mfaData || {},
        operationId: action.payload.operationId || "",
        isAuthenticated: true,
      };
    case LOGIN_SESSION_EXPIRED:
      redirectToFallback("Session expired from login flow");
      return {
        ...state,
        error: action.error,
        isAuthenticated: false,
      };
    case RESET_PSW_SESSION_EXPIRED:
      redirectToFallback("Session expired from reset password flow");
      return {
        ...state,
        error: action.error,
        isAuthenticated: false,
      };
    default:
      return state;
  }
};

export default loginReducer;
